import React from 'react';
import PropTypes from 'prop-types';
import { Table, Pagination, Row, Col } from 'antd';

DataTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    dataIndex: PropTypes.string.isRequired,
  })).isRequired,
  loading: PropTypes.bool,
  data: PropTypes.object,
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onChangePagination: PropTypes.func,
  onChange: PropTypes.func,
};

DataTable.defaultProps = {
  loading: false,
  onChangePagination: PropTypes.func,
};

function showTotal(total) {
  return `Total ${total} items`;
}

function DataTable(props) {
  return (
    <div>
      <Table
        key="table"
        loading={props.loading}
        rowKey="id"
        columns={props.columns}
        dataSource={props.data && props.data.results}
        pagination={false}
        onChange={props.onChange}
      />
      <Row type="flex" justify="end">
        <Col>
          <Pagination
            total={props.data && props.data.total}
            current={props.currentPage + 1}
            defaultCurrent={props.currentPage + 1}
            pageSize={props.pageSize}
            className="ant-pagination-table"
            showQuickJumper
            showSizeChanger
            showTotal={showTotal}
            onChange={props.onChangePagination}
            onShowSizeChange={props.onChangePagination}
          />
        </Col>
      </Row>
    </div>
  );
}

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/DataTable/index.js